// 7 Spices Indian Cuisine — Full menu data
// Each item: { num, name, desc, price }

export const RESTAURANT = {
  name: "7 Spices",
  tagline: "Indian Cuisine",
  fullName: "7 Spices Indian Cuisine",
  address: "10190 W Sample Rd, Coral Springs, FL 33065",
  phone: "(954) 344-3544",
  phoneHref: "tel:+19543443544",
  email: "Info@7spicesfl.com",
  emailHref: "mailto:Info@7spicesfl.com",
  mapsLink: "https://www.google.com/maps/dir/?api=1&destination=10190+W+Sample+Rd,+Coral+Springs,+FL+33065",
  mapsEmbed: "https://www.google.com/maps?q=10190+W+Sample+Rd,+Coral+Springs,+FL+33065&output=embed",
  uberEats: "https://www.ubereats.com/store-browse-uuid/8ab72e44-0567-5a1e-ae5e-f6f2bd15060b?diningMode=DELIVERY",
};

export const HOURS = [
  { day: "Sunday", hours: "11:00 AM – 9:30 PM" },
  { day: "Monday", hours: "11:00 AM – 9:00 PM" },
  { day: "Tuesday", hours: "11:00 AM – 9:00 PM" },
  { day: "Wednesday", hours: "11:00 AM – 9:00 PM" },
  { day: "Thursday", hours: "11:00 AM – 9:00 PM" },
  { day: "Friday", hours: "11:00 AM – 9:30 PM" },
  { day: "Saturday", hours: "11:00 AM – 9:30 PM" },
];

export const MENU_CATEGORIES = [
  {
    id: "small-plates",
    title: "Small Plates",
    items: [
      { num: 1, name: "Vegetable Samosa", desc: "Pyramid-shaped pastry stuffed potatoes | Green peas | Spices", price: "$8.00" },
      { num: 2, name: "Kurkuri Aloo Tikki", desc: "Spiced patties | Potatoes | Mix veggie | Aromatic spices", price: "$8.00" },
      { num: 3, name: "Onion Bhajiya", desc: "Thinly sliced onion | Chickpea batter fried golden brown", price: "$10.00" },
      { num: 4, name: "7 Spices Mix Platter", desc: "Assorted platter — samosa, aloo tikki, onion bhajiya, veg pakora", price: "$14.00" },
      { num: 5, name: "Tandoori Wings", desc: "Chicken wings | Tandoori marination | Clay oven", price: "$14.00" },
      { num: 6, name: "Lamb Samosa", desc: "Pyramid-shaped puff pastry | Flavored minced lamb", price: "$10.00" },
      { num: 7, name: "Amritsari Machli", desc: "Crispy fried tilapia | Yogurt | Tandoori spices", price: "$14.00" },
    ],
  },
  {
    id: "chat-station",
    title: "Chat Station",
    items: [
      { num: 8, name: "Dahi Puri", desc: "Crispy semolina puffs | Yogurt | Tamarind chutney | Spices", price: "$10.99" },
      { num: 9, name: "Pani Puri", desc: "Crispy puffed shells | Spiced potato filling | Tangy mint water", price: "$8.99" },
      { num: 10, name: "Bhel Puri", desc: "Puffed rice | Sev | Onions | Tangy tamarind sauce", price: "$8.99" },
      { num: 11, name: "Samosa Chat", desc: "Crushed samosa | Chickpeas | Yogurt | Chutneys | Spices", price: "$10.99" },
    ],
  },
  {
    id: "soups",
    title: "Soups",
    items: [
      { num: 12, name: "Lentil Soup", desc: "Classic traditional | Lentil soup | House specialty", price: "$8.00" },
      { num: 13, name: "Vegetable Manchow Soup", desc: "Mixed vegetables | Indo-Chinese spices", price: "$8.99" },
      { num: 14, name: "Chicken Manchow Soup", desc: "Chicken | Indo-Chinese spices | Crispy noodles", price: "$10.99" },
    ],
  },
  {
    id: "chicken-specialties",
    title: "Chicken Specialties",
    items: [
      { num: 15, name: "Chicken Tikka Masala", desc: "Chicken tikka cubes | Cashew paste | House special tomato gravy", price: "$22.00" },
      { num: 16, name: "Butter Chicken", desc: "Julienned tandoori chicken | Tomato gravy | Butter | Fenugreek leaves", price: "$20.00" },
      { num: 17, name: "Kerala Pepper Chicken", desc: "Black pepper | Curry leaves | Onion gravy | Kerala style", price: "$20.00" },
      { num: 18, name: "Chicken Vindaloo", desc: "Marinated chicken | Vinegar | Aromatic Goa spiced gravy | Potatoes", price: "$20.00" },
      { num: 19, name: "Chicken Korma", desc: "Chicken breast | Cashew paste | Rich creamy sauce", price: "$20.00" },
      { num: 20, name: "Kadai Chicken", desc: "Chicken cube | Cooked in a wok | Exotic spices", price: "$20.00" },
      { num: 21, name: "Andhra Chicken Curry", desc: "Chicken | Ginger | Curry leaves | Andhra curry spice", price: "$20.00" },
      { num: 22, name: "Chicken Xacutti", desc: "Chicken cube | Dry coconut | South Indian spices | Coconut milk", price: "$20.00" },
      { num: 23, name: "7 Spice Chicken Curry", desc: "Chicken cubes | House special curry", price: "$20.00" },
    ],
  },
  {
    id: "tandoor-specialties",
    title: "Tandoor Specialties",
    items: [
      { num: 24, name: "Tandoori Chicken", desc: "Marinated chicken | Spices | Herbs", price: "$19.00" },
      { num: 25, name: "Chicken Tikka", desc: "Marinated chicken breast | Yogurt | Ginger | Garlic spices", price: "$20.00" },
      { num: 26, name: "Malai Kabab", desc: "Marinated chicken breast | Cream cheese | Green chili | Cardamom", price: "$20.00" },
      { num: 27, name: "Seekh Kabab", desc: "Seasoned ground lamb | Rolled on a skewer | Char-grilled", price: "$22.00" },
      { num: 28, name: "Paneer Tikka", desc: "Cubes of homemade cheese | Marinated in red spices", price: "$18.00" },
      { num: 29, name: "Lamb Chops", desc: "Marinated rack of lamb | Fresh ginger juice | Yogurt | Spices", price: "$34.00" },
      { num: 30, name: "Mix Grill", desc: "Assorted platter of tandoori specialties", price: "$30.00" },
      { num: 31, name: "Tandoori Salmon", desc: "Tandoor-grilled salmon | House marination", price: "$22.99" },
    ],
  },
  {
    id: "vegetarian-specialties",
    title: "Vegetarian Specialties",
    items: [
      { num: 32, name: "Daal Tadka", desc: "Yellow lentils | Indian spices", price: "$16.00" },
      { num: 33, name: "Daal Makhanwala", desc: "Three lentils cooked on slow fire | Mild spices | Butter | Roasted garlic", price: "$18.00" },
      { num: 34, name: "Palak Paneer", desc: "Cottage cheese | Chopped spinach | Garam masala", price: "$18.00" },
      { num: 35, name: "Bhindi Masala", desc: "Stir-fried okra | Onions | Tomatoes | Herbs | Spices", price: "$17.00" },
      { num: 36, name: "Peshwari Chhole", desc: "Chickpeas | Dry spices | Herbs | Onions | Tomatoes", price: "$16.00" },
      { num: 37, name: "Paneer Makhani", desc: "Paneer | Rich tomato gravy | Butter", price: "$18.00" },
      { num: 38, name: "Mutter Paneer", desc: "Paneer cubes | Green peas | Onions | Rich herb gravy", price: "$18.00" },
      { num: 39, name: "Malai Kofta", desc: "Cottage cheese and veggie balls | Light creamy sauce", price: "$18.00" },
      { num: 40, name: "Aloo Gobi", desc: "Florets of cauliflower | Exotic Indian spices", price: "$16.00" },
      { num: 41, name: "Chole Bhatura", desc: "Spiced chickpeas | Fluffy fried bread", price: "$16.99" },
    ],
  },
  {
    id: "seafood-specialties",
    title: "Seafood Specialties",
    items: [
      { num: 42, name: "Kadai Shrimp", desc: "Shrimp cube | Cooked in a wok | Exotic spices", price: "$23.00" },
      { num: 43, name: "Shrimp Tikka Masala", desc: "Tandoori shrimp | Cashew paste | Tomato gravy | House special", price: "$23.00" },
      { num: 44, name: "Andhra Fish Curry", desc: "Mahi mahi fish | Dry chili | Tomato sauce", price: "$22.00" },
      { num: 45, name: "Goan Shrimp Curry", desc: "Goan specialty | Prawns | Coconut | Cumin | Curry leaves", price: "$23.00" },
      { num: 46, name: "Goan Fish Curry", desc: "Mahi mahi | Coconut | Cumin | Curry leaves", price: "$23.00" },
    ],
  },
  {
    id: "lamb-specialties",
    title: "Lamb Specialties",
    items: [
      { num: 47, name: "Lamb Korma", desc: "Creamy sauce | Cashew paste | Boneless lamb", price: "$22.00" },
      { num: 48, name: "Lamb Tikka Masala", desc: "Boneless lamb tikka | Rich tomato gravy | House special", price: "$22.00" },
      { num: 49, name: "Kadai Gosht", desc: "Lamb cubes | Cooked in a wok | Exotic spices | Onions | Tomatoes", price: "$22.00" },
      { num: 50, name: "Punjabi Goat Curry", desc: "Bone-in goat | Onion-based sauce | North Indian specialty", price: "$20.00" },
      { num: 51, name: "Lamb Roganjosh", desc: "Broiled lamb cubes | Zesty gravy | Kashmiri spice | Yogurt", price: "$22.00" },
      { num: 52, name: "Lamb Vindaloo", desc: "Marinated lamb | Vinegar | Aromatic Goa spiced gravy | Potatoes", price: "$22.00" },
      { num: 53, name: "7 Spices Lamb Curry", desc: "Tender lamb cubes | Onion gravy | Chef special", price: "$20.00" },
      { num: 54, name: "Andhra Lamb Curry", desc: "Roasted black pepper | Curry leaves | Byadgi chilly", price: "$20.00" },
      { num: 55, name: "Kadai Lamb", desc: "Stir-fried lamb | Onion tomato masala | Kadai spice blend", price: "$23.99" },
    ],
  },
  {
    id: "chinese-station",
    title: "Chinese Station",
    items: [
      { num: 56, name: "Veg Schezwan Noodles", desc: "Stir-fried noodles | Mixed vegetables | Spicy Schezwan sauce", price: "$16.99" },
      { num: 57, name: "Chicken Schezwan Noodles", desc: "Stir-fried noodles | Chicken | Spicy Schezwan sauce", price: "$19.99" },
      { num: 58, name: "Shrimp Schezwan Noodles", desc: "Stir-fried noodles | Shrimp | Spicy Schezwan sauce", price: "$21.99" },
      { num: 59, name: "Veg Schezwan Fried Rice", desc: "Fried rice | Mixed vegetables | Spicy Schezwan sauce", price: "$16.99" },
      { num: 60, name: "Chicken Schezwan Fried Rice", desc: "Fried rice | Chicken | Spicy Schezwan sauce", price: "$19.99" },
      { num: 61, name: "Shrimp Schezwan Rice", desc: "Fried rice | Shrimp | Spicy Schezwan sauce", price: "$21.99" },
      { num: 62, name: "Baby Corn Chilli", desc: "Indo-Chinese | Baby corn | Chilly sauce | Sautéed onions | Pepper", price: "$13.00" },
      { num: 63, name: "Gobi Manchurian Dry", desc: "Crispy cauliflower | Garlic sauce", price: "$16.99" },
      { num: 64, name: "Chicken 65", desc: "Indo-Chinese | Breaded chicken | Chilly garlic sauce | Sautéed onions | Bell pepper", price: "$17.99" },
    ],
  },
  {
    id: "rice-delicacies",
    title: "Rice Delicacies",
    items: [
      { num: 69, name: "Veg Biryani", desc: "Garden veggies | Paneer | Saffron rice | Aromatic spices", price: "$18.00" },
      { num: 70, name: "Goat Biryani", desc: "Goat | Saffron rice | Aromatic spices", price: "$23.00" },
      { num: 71, name: "Chicken Biryani", desc: "Chicken breast | Saffron rice | Aromatic spices", price: "$20.00" },
      { num: 72, name: "Shrimp Biryani", desc: "Shrimp | Saffron rice | Aromatic spices", price: "$23.00" },
      { num: 73, name: "Lamb Biryani", desc: "Lamb | Saffron rice | Aromatic spices", price: "$22.00" },
      { num: 74, name: "Egg Biryani", desc: "Egg | Saffron rice | Aromatic spices", price: "$19.99" },
      { num: 75, name: "Biryani Rice", desc: "Basmati rice | Exotic spices", price: "$14.00" },
      { num: 76, name: "Rice", desc: "Long-grain basmati rice", price: "$4.00" },
      { num: 77, name: "Papad (4 pieces)", desc: "Grilled wafers | Black pepper | Cumin seeds", price: "$4.00" },
      { num: 78, name: "Plain Yogurt", desc: "Homemade yogurt", price: "$3.00" },
    ],
  },
  {
    id: "bread-delicacies",
    title: "Bread Delicacies",
    items: [
      { num: 87, name: "Naan / Butter Naan", desc: "A light & fluffy bread", price: "$5.50" },
      { num: 88, name: "Garlic Naan", desc: "Unleavened bread topped with garlic butter", price: "$5.75" },
      { num: 89, name: "Tandoori Roti", desc: "Whole wheat bread", price: "$5.50" },
      { num: 90, name: "Bullet Naan", desc: "Unleavened bread topped w/ cilantro & cut green peppers", price: "$5.00" },
      { num: 91, name: "Kheema Naan", desc: "Naan stuffed with minced lamb", price: "$8.00" },
      { num: 92, name: "7 Spice Special Naan", desc: "Naan topped w/ dried fruit & nuts", price: "$8.00" },
      { num: 93, name: "Cheese Naan", desc: "Naan stuffed with homemade spiced cheese", price: "$6.00" },
      { num: 94, name: "Lachcha Paratha", desc: "Multi-layered wheat bread topped with butter", price: "$6.00" },
      { num: 95, name: "Onion Kulcha", desc: "Wheat bread stuffed with onions & spices", price: "$5.00" },
    ],
  },
  {
    id: "desserts-beverages",
    title: "Desserts & Beverages",
    items: [
      { num: 79, name: "Kesari Rasmalai", desc: "Pressed cheese | Pistachios | Condensed milk", price: "$6.00" },
      { num: 80, name: "Gulab Jamoon", desc: "Dry milk dumplings | Rose | Saffron", price: "$6.00" },
      { num: 81, name: "Kulfi", desc: "House-made pistachio ice cream", price: "$6.00" },
      { num: 82, name: "Gajar Halwa", desc: "Grated carrot pudding", price: "$6.00" },
      { num: 83, name: "Chaas", desc: "Buttermilk | Cumin | Coriander | Curry leaves", price: "$6.00" },
      { num: 84, name: "Mango Lassi", desc: "Sweet yogurt drink | Ripe mango | Cardamom", price: "$6.00" },
      { num: 85, name: "Sweet Lassi", desc: "Sweetened yogurt | Rose water | Cardamom", price: "$6.00" },
      { num: 86, name: "Masala Soda", desc: "Sparkling water | Lemon | Black salt | Spices", price: "$6.00" },
    ],
  },
  {
    id: "drinks",
    title: "Drinks",
    items: [
      { num: 65, name: "Indian Chai", desc: "Spiced tea | Milk | Ginger | Cardamom", price: "$3.99" },
      { num: 66, name: "Madras Coffee", desc: "Authentic filter coffee | Steamed milk | Frothy top", price: "$3.99" },
      { num: 67, name: "Limca", desc: "Indian lemon-lime soda", price: "$3.50" },
      { num: 68, name: "Thumbs Up", desc: "Classic Indian cola", price: "$3.50" },
    ],
  },
];

export const SIGNATURE_DISHES = [
  {
    name: "Chicken Tikka Masala",
    desc: "Chicken tikka cubes simmered in our house-special cashew tomato gravy.",
    price: "$22.00",
    image: "https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  },
  {
    name: "Butter Chicken",
    desc: "Julienned tandoori chicken in silky tomato gravy with butter and fenugreek.",
    price: "$20.00",
    image: "https://images.unsplash.com/photo-1742599361498-79824d24e355?auto=format&fit=crop&w=1200&q=80",
  },
  {
    name: "Goat Biryani",
    desc: "Bone-in goat layered with saffron basmati and aromatic spices, dum-cooked.",
    price: "$23.00",
    image: "https://images.pexels.com/photos/33947401/pexels-photo-33947401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
  },
  {
    name: "Paneer Tikka",
    desc: "Homemade cheese cubes marinated in red spices, char-grilled in the tandoor.",
    price: "$18.00",
    image: "https://images.unsplash.com/photo-1727404746799-253aa9a8ace6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmb29kJTIwY2luZW1hdGljJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTQ1NjU1NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Chicken 65",
    desc: "Indo-Chinese breaded chicken tossed in chilly garlic, onions & bell peppers.",
    price: "$17.99",
    image: "https://images.unsplash.com/photo-1697155836250-e3ba3a24fbd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHx0YW5kb29yaSUyMGNoaWNrZW4lMjByZXN0YXVyYW50JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzgxNDU2NTU0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1727404746799-253aa9a8ace6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmb29kJTIwY2luZW1hdGljJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTQ1NjU1NHww&ixlib=rb-4.1.0&q=85";
export const KITCHEN_IMAGE = "https://images.pexels.com/photos/17086289/pexels-photo-17086289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";
